<template>
  <div style="min-height: 100vh; background-color: #E7EFFE;">
    <div class="about-us">
      <div style="position: fixed; width: 100%; z-index: 1">
        <div style="padding: 24px 16px 20px 16px; background-color: #E7EFFE;">
          <div class="account">
            <div class="left">
              <div class="name">{{ introduction.name }}</div>
              <div class="description">{{ introduction.remark }}</div>
              <div class="tags">
                <div class="tag" v-if="introduction.sports_soccer === 1">足球</div>
                <div class="tag" v-if="introduction.sports_basketball === 1">篮球</div>
                <div class="tag" v-if="introduction.sports_badminton === 1">羽毛</div>
                <div class="tag" v-if="introduction.sports_table_tennis === 1">乒乓球</div>
                <div class="tag" v-if="introduction.sports_tennis === 1">网球</div>
                <div class="tag" v-if="introduction.sports_baseball === 1">棒球</div>
                <div class="tag" v-if="introduction.sports_football === 1">橄榄球</div>
                <div class="tag" v-if="introduction.sports_volleyball === 1">排球</div>
                <div class="tag" v-if="introduction.sports_hockey === 1">冰球</div>
                <div class="tag" v-if="introduction.sports_other_value">{{ introduction.sports_other_value }}</div>
              </div>
            </div>
            <div class="right">
              <img :src="imageView(introduction.logo, 50, 50)" alt="">
            </div>
          </div>
        </div>
        <div v-if="introduction.introModel === 0">
          <div class="tabs">
            <div v-if="introduction.about" class="base-tab" :class="activeIndex === 0 ? 'active-tab' : ''" @click="go('us')">关于我们</div>
            <div v-if="honor.length > 0" class="base-tab" @click="go('honor')">获得荣誉</div>
            <div v-if="progress.length > 0" class="base-tab" @click="go('progress')">发展历程</div>
            <div v-if="introduction.partnership.length > 0" class="base-tab" @click="go('partnership')">合作伙伴</div>
            <div v-if="contactDepart.length > 0" class="base-tab" @click="go('contactDepart')">联系我们</div>
          </div>
          <div class="my-tab" :style="{ left: activeIndex * metaWidth + 14 + 'px' }"></div>
        </div>
      </div>
      <div style="height: 187px;" v-if="introduction.introModel === 0"></div>
      <div style="height: 134px;" v-else></div>
      <div v-if="introduction.introModel === 0">
        <div v-if="introduction.about">
          <div id="us" class="point-place"></div>
          <div class="title"><span></span>关于我们</div>
          <div class="us-info">{{ introduction.about }}</div>
          <div style="background-color: #F6F6F8; height: 12px;"></div>
        </div>
        <div v-if="honor.length > 0">
          <div id="honor" class="point-place"></div>
          <div class="title"><span></span>获得荣誉</div>
          <div class="honors">
            <div class="honor-info" v-for="(item, index) in honor" :style="{'margin-top': index > 0 ? '12px' : '0'}" :key="index">
              <img src="../../assets/honor.png" style="width: 16px; height: 16px; margin-right: 4px" alt="">
              <span>{{ item }}</span>
            </div>
          </div>
          <div style="background-color: #F6F6F8; height: 12px;"></div>
        </div>
        <div v-if="progress.length > 0">
          <div id="progress" class="point-place"></div>
          <div class="title"><span></span>发展历程</div>
          <div class="progresses">
            <div class="progress-info" v-for="(item, index) in progress" :key="index">
              <div class="year">
                <div class="point"></div>
                {{ item.year }} 年
              </div>
              <div class="info" :style="{'border-left': index < (progress.length - 1) ? '1px #1565FC dashed' : 'none'}">{{ item.info }}</div>
            </div>
          </div>
          <div style="background-color: #F6F6F8; height: 12px;"></div>
        </div>
        <div v-if="introduction.partnership.length > 0">
          <div id="partnership" class="point-place"></div>
          <div class="title"><span></span>合作伙伴</div>
          <div class="partnerships">
            <van-image
                v-for="(item, index) in introduction.partnership"
                :src="imageView(item)"
                :key="index"
                fit="contain"
                style="width: 107px; height: 63px; margin-bottom: 10px;"
            />
            <div style="width: 107px;"></div>
            <div style="width: 107px;"></div>
          </div>
          <div style="background-color: #F6F6F8; height: 12px;"></div>
        </div>
        <div v-if="contactDepart.length > 0">
          <div id="contactDepart" class="point-place"></div>
          <div class="title"><span></span>联系我们</div>
          <div class="contact-us">
            <div class="contact-info" v-for="(item, index) in contactDepart" :key="index">
              <div class="department">{{ item.department }}</div>
              <div class="card">
                <div class="name">{{ item.contactName }}</div>
                <div class="base-style">{{ item.contactAddress }}</div>
                <div class="base-style">{{ item.contactMobile }}</div>
                <div class="base-style">{{ item.contactEmail }}</div>
              </div>
            </div>
          </div>
        </div>
        <div style="padding-top: 60px" v-if="!introduction.about && honor.length === 0 && progress.length === 0 && introduction.partnership.length === 0 && contactDepart.length === 0 && contactDepart.length === 0">
          <img src="../../assets/empty.png" style="width: 232px; height: 150px; margin: 0 auto" alt="">
          <div style="color: #8C8C8C; font-size: 14px; padding-top: 14px; text-align: center">装修中，敬请期待～</div>
        </div>
        <div style="height: 50vh; background-color: #FFFFFF;"></div>
      </div>
      <div style="padding: 12px" v-else>
        <span ref="custom">
          {{ introduction.custom }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tab, Tabs, Image as VanImage } from 'vant'
Vue.use(Tab).use(Tabs).use(VanImage)
import { getCrmAccountIntro } from '@/api/match'
import {QNImageUtil} from "@/utils";
export default {
  data() {
    return {
      id: '',
      introduction: {},
      honor: [],
      progress: [],
      contactDepart: [],
      activeIndex: 0,
      metaWidth: 1,
      s365Top: 0
    }
  },
  mounted() {
    this.id = this.$route.params.accountId
    this.getCrmAccountIntro()
    document.addEventListener('scroll', () => {
      let hasChanged = false
      const points = document.querySelectorAll('.point-place')
      points.forEach((item, index) => {
        if (!hasChanged && window.scrollY < item.offsetTop - 125) {
          hasChanged = true
          this.changeSelected(index)
        }
      })
    })
  },
  methods: {
    changeSelected(index) {
      this.activeIndex = index
    },
    getCrmAccountIntro() {
      const params = {
        id: this.id
      }
      getCrmAccountIntro(params).then(res => {
        if (res) {
          const { data } =  res
          this.introduction = data.introduction
          document.title = this.introduction.name
          const shareObj = {
            title: this.introduction.name,
            abstract: this.introduction.remark,
            image: QNImageUtil.imageView(this.introduction.logo)
          }
          this.wxShare(shareObj)
          this.introduction.partnership = this.introduction.partnership && this.introduction.partnership.split(',') || []
          this.honor = data.introduction.honor && JSON.parse(data.introduction.honor) || []
          this.progress = data.introduction.progress && JSON.parse(data.introduction.progress) || []
          this.contactDepart = data.introduction.contactDepart && JSON.parse(data.introduction.contactDepart) || []
          let n = 1
          if (this.introduction.partnership.length > 0) n++
          if (this.honor.length > 0) n++
          if (this.progress.length > 0) n++
          if (this.contactDepart.length > 0) n++
          this.metaWidth = ((window.innerWidth - 30 - n * 58) / (n - 1)) + 58
          if (this.introduction.introModel === 1) {
            this.$refs.custom.innerHTML = this.introduction.custom
          }
          this.$nextTick(() => {
            const t = document.querySelector('.my-tab')
            if (t) {
              t.style.top = t.offsetTop - 6 + 'px'
            }
          })
        }
      })
    },
    go(id) {
      const element = document.getElementById(id)
      window.scrollTo(0,  element.offsetTop - 187)
      // let baseStep = window.scrollY > (element.offsetTop - 187) ?
      //     Math.round((window.scrollY - element.offsetTop + 187) / 100) :
      //     Math.round((element.offsetTop - 187 - window.scrollY) / 100)
      // if (baseStep <= 0) baseStep = 1
      // while (window.scrollY > element.offsetTop - 187) {
      //   setTimeout(() => {
      //     window.scrollTo(0, window.scrollY - baseStep)
      //   }, 3)
      // }
      // while (window.scrollY < element.offsetTop - 187) {
      //   setTimeout(() => {
      //     window.scrollTo(0, window.scrollY + baseStep)
      //   }, 3)
      // }
    },
    imageView(img, w, h) {
      if (!img) return ''
      return QNImageUtil.imageView(img, w, h)
    }
  }
}
</script>

<style scoped lang="scss">
.about-us {
  background-color: #FFFFFF;
  border-radius: 12px 12px 0 0;
  position: relative;
  .account {
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    padding: 18px 16px;
    border-radius: 4px;
    .left {
      .name {
        color: #333333;
        font-weight: 500;
        font-size: 16px;
        overflow:hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
      .description {
        color: #8C8C8C;
        font-size: 15px;
        padding: 8px 0;
        overflow:hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
      .tags {
        height: 18px;
        overflow: hidden;
        .tag {
          display: inline-block;
          height: 18px;
          line-height: 18px;
          background-color: #EBF2FF;
          color: #1565FC;
          padding: 0 8px;
          margin-left: 6px;
        }
      }
    }
    .right {
      width: 50px;
      height: 50px;
      border-radius: 4px;
      overflow: hidden;
    }
  }
  .tabs {
    display: flex;
    justify-content: space-between;
    height: 48px;
    padding: 20px 15px 14px 15px;
    border-radius: 12px 12px 0 0;
    box-sizing: border-box;
    background-color: #FFFFFF;
    .base-tab {
      font-size: 14px;
      color: #191919;
    }
    .active-tab {
      font-weight: 500;
    }
  }
  .my-tab {
    position: absolute;
    left: 15px;
    background-color: #282828;
    width: 58px;
    height: 2px;
    transition: all 0.3s;
  }
  .title {
    display: flex;
    align-items: center;
    font-size: 15px;
    color: #333333;
    font-weight: 500;
    padding: 25px 0 13px 0;
    margin: 0 16px;
    border-bottom: 1px #EEEEEE solid;
    span {
      width: 2px;
      height: 12px;
      background-color: #2D60DF;
      margin-right: 8px;
    }
  }
  .us-info {
    padding: 12px 12px 16px 12px;
    color: #282828;
    font-size: 13px;
  }
  .honors {
    padding: 16px;
    .honor-info {
      display: flex;
      align-items: center;
      color: #282828;
      font-size: 13px;
    }
  }
  .progresses {
    padding: 20px 0 24px 21px;
    .progress-info {
      .year {
        display: flex;
        align-items: center;
        color: #282828;
        font-size: 12px;
        font-weight: 500;
        .point {
          background-color: #1565FC;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          margin-right: 8px;
        }
      }
      .info {
        height: 24px;
        margin-left: 3px;
        padding-left: 10px;
        padding-top: 3px;
        font-size: 12px;
        color: #282828;
        box-sizing: border-box;
      }
    }
  }
  .partnerships {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 8px 16px 18px 16px;
    z-index: 0;
  }
  .contact-us {
    padding: 12px 15px 16px 11px;
    .contact-info {
      .department {
        padding: 12px;
        font-size: 11px;
        color: #8C8C8C;
      }
    }
    .card {
      background-color: #F6F6F8;
      padding: 12px 12px;
      border-radius: 4px;
      .name {
        color: #191919;
        font-size: 14px;
        font-weight: 500;
      }
      .base-style {
        color: #282828;
        font-size: 11px;
        line-height: 20px;
      }
    }
  }
}
</style>
